/** The Ostrel brand mark (the gold node + strokes from the brand SVG),
 *  sized by the parent via width/height. Used in the sidebar, the login
 *  brand panel, and anywhere the full logo belongs instead of the old
 *  rotated-square glyph. */
export function OstrelMark({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 220 220" aria-hidden="true">
      <rect width="220" height="220" rx="46" fill="var(--color-ostrel-navy)" />
      <g transform="translate(110,110)">
        <path
          d="M-60 0 L -32 0 M-8 0 C 18 0, 20 -32, 58 -32 M-8 0 L 58 0 M-8 0 C 18 0, 20 32, 58 32"
          stroke="var(--color-ostrel-light)"
          strokeWidth="11"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="-20" cy="0" r="15" fill="var(--color-ostrel-gold)" />
      </g>
    </svg>
  )
}
